import React, { useRef, useEffect } from "react";
import { useLocation } from "react-router";
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
import ContactForm from "../../components/contactform/contactform";
import Services from "../../components/services/services";
import Pod from "../../components/pod/pod";
import Hero from "../../components/hero/hero";
import heroImage from "../../assets/hero-image-dev.png";
import "./home.css";

const SKILLS = [
  "C# / .NET Core", "ASP.NET Web API", "MVC", "WPF", "Node.js", "React.js",
  "React Native", "Angular", "Next.js", "TypeScript", "JavaScript", "Python",
  "C / C++", "Azure", "AWS", "Azure DevOps", "AKS / Kubernetes", "Docker",
  "Microservices", "Entity Framework", "RESTful APIs", "Redis Cache",
  "SQL / Oracle", "Salesforce", "PowerShell", "CI/CD", "OWASP Security",
  "Generative AI", "Solution Architecture", "Agile / Scrum"
];

function Home() {
  const contactRef = useRef(null);
  const location = useLocation();

  const scrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  useEffect(() => {
    if (location.hash === "#contact") {
      // allow the section to render before scrolling
      setTimeout(scrollToContact, 100);
    }
  }, [location]);

  return (
    <div className="home-container" id="home">
      <Header onContact={scrollToContact} />

      <Hero image={heroImage} onContact={scrollToContact} />

      <Services />

      {/* ABOUT */}
      <section id="about" className="block">
        <div className="container">
          <div className="section-head">
            <span className="eyebrow"><span className="dot"></span>More About Me</span>
            <h2>Background &amp; Credentials</h2>
          </div>
          <div className="pods">
            <Pod title="Engineering Manager & Solution Architect">
              <p>Based in Ohio, USA, I lead architectural vision, technical strategy and end-to-end delivery across multiple engineering teams — aligning product goals, delivery milestones and stakeholder expectations.</p>
              <p>I translate complex operational requirements into scalable, secure and reliable solutions, driving Agile/Scrum practices and supporting pre-sales, discovery and solution design.</p>
            </Pod>
            <Pod title="Qualifications & Certifications">
              <ul>
                <li>BSc. (Hons) in Information Technology</li>
                <li>Salesforce Platform Developer I (2025)</li>
                <li>Microsoft Azure DevOps Engineer Expert (2024)</li>
                <li>Microsoft Azure Developer Associate (2020)</li>
                <li>Azure Data &amp; AI Fundamentals (2023)</li>
                <li>Career Essentials in Generative AI (2023)</li>
              </ul>
            </Pod>
            <Pod title="Core Strengths">
              <ul>
                <li>Enterprise &amp; solution architecture</li>
                <li>Cloud migration &amp; modernization (Azure/AWS)</li>
                <li>AI integration &amp; data engineering</li>
                <li>DevSecOps, CI/CD &amp; automation</li>
                <li>Integration design &amp; API security</li>
                <li>Team leadership &amp; mentoring</li>
              </ul>
            </Pod>
            <Pod title="Domain Experience & Beyond">
              <p>Delivered mission-critical solutions across healthcare, hospitality and retail domains — meeting stringent standards such as HIPAA and OWASP.</p>
              <p>A technical author, speaker and mentor, I build reusable frameworks and share knowledge to grow the next generation of engineering leaders.</p>
            </Pod>
          </div>
        </div>
      </section>

      {/* SKILLS */}
      <section id="skills" className="block">
        <div className="container">
          <div className="section-head">
            <span className="eyebrow"><span className="dot"></span>Toolbox</span>
            <h2>Technologies &amp; Skills</h2>
            <p>A broad, battle-tested stack spanning languages, frameworks, cloud and architecture practice.</p>
          </div>
          <div className="skills">
            {SKILLS.map((s) => (
              <span className="skill" key={s}>{s}</span>
            ))}
          </div>
        </div>
      </section>

      {/* CONTACT */}
      <section id="contact" className="block" ref={contactRef}>
        <div className="container">
          <ContactForm />
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Home;
